<template>
  <tr class="exercise-row" :class="user.selected ? 'selected' : ''" @click="$emit('preview-exercise', user.id, user.type)">
    <td class="exercise-col">
      <div class="exercise__avatar">
        <multi-thumbnail v-if="multiThumbnailComputed" :media="multiThumbnailComputed" />
        <img v-else :src="thumbnailUrlComputed" :alt="user.title" />
      </div>
    </td>
    <td class="exercise-col full-width">
      <h6 v-if="user.type == 'SERIES'" class="exercise__type">circuit</h6>
      <h6 v-else-if="user.type == 'ACTIVITY'" class="exercise__type">activity</h6>
      <h6 v-else-if="user.type == 'EXERCISE'" class="exercise__type">exercise</h6>
      <h4 class="exercise__name">{{ user.title }}</h4>
      <p v-if="user.description" class="exercise__description">{{user.description}}</p>
    </td>
    <td class="exercise-col">
      <v-btn small rounded color="accent" elevation="0" @click.native.stop="$emit('choose-exercise', user.id, user.type)">
        Add
      </v-btn>
    </td>
  </tr>
</template>

<script>
import MultiThumbnail from '@/components/avatars/MultiThumbnail'

export default {
  name: 'ExerciseDefinitionTableRow',
  components: {
    MultiThumbnail
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    multiThumbnailComputed() {
      return this.user?.series?.exerciseDefinitions?.map(item=>{
        if (item.media) item.thumbnailUrl = item.media.thumbnailUrl
        if (!item.media?.thumbnailUrl && item.additionalMedia) item.thumbnailUrl = item.additionalMedia.thumbnailUrl
        if (!item.thumbnailUrl && item.mobileStaticMedia?.mediaUrl) item.thumbnailUrl = item.mobileStaticMedia.mediaUrl
        return item
      })
    },
    mobileStaticMedia() {
      return this.user?.mobileStaticMedia || this.user?.series?.mobileStaticMedia || this.user?.activity?.mobileStaticMedia || this.user?.exercise?.mobileStaticMedia
    },
    thumbnailUrlComputed() {
      return this.user?.media?.thumbnailUrl || this.user?.additionalMedia?.thumbnailUrl || this.mobileStaticMedia?.mediaUrl || require('@/assets/placeholder48x54.png')
    }
  }
}
</script>

<style lang="scss">
table {
  min-width: 0 !important;
  width: 100% !important;
}
.exercise {
  &__name {
    // what about wrapping names?
    min-width: 150px;
    margin-bottom: 4px;
    cursor: pointer;
    text-align: left;
    padding-left:16px;
    // do we hant hover style?
    // &:hover {
    //   text-decoration: underline;
    // }
  }
  &__type {
    min-width: 150px;
    margin-bottom: 0px;
    cursor: pointer;
    text-align: left;
    font-size: 10px;
    padding-left:16px;
    font-weight: bold;
    color: $bh-gray--2;
  }
  &__description {
    text-align: left;
    padding-left: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 260px;
  }

  &__avatar {
    overflow: hidden;
    border-radius: 8px;
    width: 48px;
    height: 48px;
    img {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }

  &-row {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.04);
    border-radius: $border-radius-root;
    cursor: pointer;
    td {
      border-top: 2px solid $bh-white;
      border-bottom: 2px solid $bh-white !important;
      &:first-child {
        border-left: 2px solid $bh-white;
      } 
      &:last-child {
        border-right: 2px solid $bh-white;
      } 
    }
    &.selected {
      td {
        border-color: $bh-blue !important;
      }
    }
    &:hover {
      background: transparent !important;
    }
  }

  &-col {
    padding: 8px 4px !important;
    background: $bh-white;
    margin: 2px 0;
    &.full-width {
      width: 100%;
    }
    strong {
      display: inline-block;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p {
      font-size: 0.857rem;
      line-height: 1rem;
    }

    p:last-child {
      margin-bottom: 0;
    }

    &:first-of-type {
      min-width: 0;
      border-top-left-radius: $border-radius-root;
      border-bottom-left-radius: $border-radius-root;
    }

    &:last-of-type {
      min-width: 0;
      border-top-right-radius: $border-radius-root;
      border-bottom-right-radius: $border-radius-root;
      text-align: right;
    }

    .text-number {
      font-size: 1.125rem;
    }
  }
}
</style>
